import { Routes } from '@angular/router';
import { ConfirmAuthGuardService } from '@msi/commandcentral-common-header';
import { CanDeactivateGuard, DemoEnvironmentGuard } from './services/routeGuard/route-guard.service';

export const internalRoutes: Routes = [
	{
		// Workflows route
		path: 'workflows',
		loadComponent: () =>
			import('./components/workflow-dashboard/workflow-dashboard.component').then(m => m.WorkflowDashboardComponent),
		canActivate: [ConfirmAuthGuardService],
		canDeactivate: [CanDeactivateGuard],
	},
	{
		// Workspace route
		path: 'workflows/:id',
		loadComponent: () => import('./components/workspace/workspace.component').then(m => m.WorkspaceComponent),
		canActivate: [ConfirmAuthGuardService],
		canDeactivate: [CanDeactivateGuard],
	},
	{
		// Monitor route
		path: 'monitor',
		loadComponent: () => import('./components/monitor-page/monitor-page.component').then(m => m.MonitorPageComponent),
		canActivate: [ConfirmAuthGuardService],
		canDeactivate: [CanDeactivateGuard],
		loadChildren: () => [
			{
				path: 'charts',
				loadComponent: () => import('./components/charts-page/charts-page.component').then(m => m.ChartsPageComponent),
			},
			{
				path: 'runtime-data',
				loadComponent: () =>
					import('./components/runtime-data/runtime-data.component').then(m => m.RuntimeDataComponent),
			},
			{
				path: 'system-health',
				loadComponent: () =>
					import('./components/system-health/system-health.component').then(m => m.SystemHealthComponent),
			},
			{ path: '**', redirectTo: 'runtime-data' },
		],
	},
	{
		// Legacy system health page route
		path: 'system-health',
		redirectTo: 'monitor/system-health',
	},
	{
		// Legacy runtime data page route
		path: 'runtime-data',
		redirectTo: 'monitor/runtime-data',
	},
	{
		// Connection center page route
		path: 'connections',
		loadComponent: () =>
			import('./components/connection-center/connection-center.component').then(m => m.ConnectionCenterComponent),
		canActivate: [ConfirmAuthGuardService],
		canDeactivate: [CanDeactivateGuard],
	},
	{
		// Connection center details page route
		path: 'connections/:id',
		loadComponent: () =>
			import('./components/connection-center/product-details/product-details.component').then(
				m => m.ProductDetailsComponent
			),
		canActivate: [ConfirmAuthGuardService],
		canDeactivate: [CanDeactivateGuard],
	},
	{
		// Connection center details page route
		path: 'connections/:id/config',
		loadComponent: () =>
			import('./components/connection-center/config-page/config-page.component').then(m => m.ConfigPageComponent),
		canActivate: [ConfirmAuthGuardService],
		canDeactivate: [CanDeactivateGuard],
	},
	{
		// Settings page routes
		path: 'settings',
		loadComponent: () =>
			import('./components/settings-screen/settings-screen.component').then(m => m.SettingsScreenComponent),
		canActivate: [ConfirmAuthGuardService],
		canDeactivate: [CanDeactivateGuard],
		loadChildren: () => [
			{
				path: 'demo',
				loadComponent: () =>
					import('./components/settings-screen/demo-settings/demo-settings.component').then(
						m => m.DemoSettingsComponent
					),
				canActivate: [DemoEnvironmentGuard],
			},
			{
				path: 'orch',
				loadComponent: () =>
					import('./components/settings-screen/orch-settings/orch-settings.component').then(
						m => m.OrchSettingsComponent
					),
			},
			{ path: '**', redirectTo: 'orch' },
		],
	},
	{
		// Self registration setup screen
		path: 'self-registration-setup',
		loadComponent: () =>
			import('./components/self-registration/self-registration.component').then(m => m.SelfRegistrationComponent),
		data: { preload: false },
	},
	{
		// EULA page
		path: 'eula',
		loadComponent: () => import('./components/eula-page/eula-page.component').then(m => m.EulaPageComponent),
		data: { preload: false },
	},
	{
		// Error screen
		path: 'error',
		loadComponent: () => import('./components/error-screen/error-screen.component').then(m => m.ErrorScreenComponent),
		canActivate: [ConfirmAuthGuardService],
		canDeactivate: [CanDeactivateGuard],
	},
	{
		// Superhighway with simulated backend demo route
		path: 'sh-demo',
		loadComponent: () =>
			import('./components/simulated-superhighway/simulated-superhighway.component').then(
				m => m.SimulatedSuperhighwayComponent
			),
		canActivate: [ConfirmAuthGuardService, DemoEnvironmentGuard],
		canDeactivate: [CanDeactivateGuard],
	},
	// Redirect anything else to workflow dashboard route
	{ path: '**', redirectTo: 'workflows' },
];

// Copyright (c) Motorola Solutions Inc. All Rights Reserved.
